const {ContactInformationModel} = require('./ContactInformationModel')
const {AddressModel} = require( './AddressModel')
const {Sign} = require( './Sign')
const {Account, Roles} = require('./Account')
const {Adjustment} = require('./Adjustment')
const {PaymentHistory} = require('./PaymentHistory')
const {equals} = require('./Equals')
const {JustDate} = require('./JustDate')
const dateFormat = require('dateformat')

/**
 * This is a quote model
 */
class Quote {
    /**
     * @param {string} id
     * @param {string} givenId
     * @param {string} jobName
     * @param {string} customerName
     * @param {[Sign]} signs
     * @param {ContactInformationModel} asanteContactInfo
     * @param {ContactInformationModel} contactInfo
     * @param {shippingInfo} shippingInfo
     * @param {string} comments
     * @param {string} projectManager
     * @param {boolean} isThermoformed
     * @param {[Adjustment]} adjustments
     * @param {number} shippingCost
     * @param {Date} quoteDate
     * @param {number} totalPrice
     * @param {boolean} isShipped
     * @param {Date} shippedDate
     * @param {string} materials
     * @param {[string]} trackingNumber
     * @param {string} billingComments
     * @param {json} customerProjectManager
     * @param {ContactInformationModel} invoiceContactInfo
     * @param {string} projectManagerComment
     * @param {JustDate} lastDatePaid
     * @param {boolean} adminPaid
     * @param {[PaymentHistory]} paymentHistory
     * @param {number} leftToPay
     */
    constructor(id='', givenId=null,
        jobName='', customerName='',
        signs=[new Sign()], asanteContactInfo=null,
        contactInfo=null,
        shippingInfo=null, comments='', projectManager='',
        isThermoformed=false,
        adjustments=[new Adjustment()],
        shippingCost=0.0,
        quoteDate=new JustDate(), totalPrice=0.0, isShipped=false,
        shippedDate=null, materials='',
        trackingNumber=[''],
        billingComments='',
        customerProjectManager=null,
        invoiceContactInfo=null,
        projectManagerComment='',
        lastDatePaid=null,
        adminPaid=false,
        paymentHistory=[],
        leftToPay=0.0,
        quoteSequence=1,
    ) {
        this.id = id
        this.given_id = givenId
        this.job_name = jobName
        this.customer_name = customerName
        this.signs = signs
        this.asante_contact_info = asanteContactInfo
        this.contact_info = contactInfo
        this.shipping_info = shippingInfo
        this.comments = comments
        this.project_manager = projectManager
        this.is_thermoformed = isThermoformed
        this.adjustments = adjustments
        this.shipping_cost = shippingCost
        this.quote_date = quoteDate
        this.total_price = totalPrice
        this.is_shipped = isShipped
        this.shipped_date = shippedDate
        this.materials = materials
        this.tracking_number = trackingNumber
        this.billing_comments = billingComments
        this.customer_project_manager = customerProjectManager
        this.invoicing_contact_info = invoiceContactInfo
        this.project_manager_comment = projectManagerComment
        this.last_date_paid = lastDatePaid
        this.admin_paid = adminPaid
        this.payment_history = paymentHistory
        this.left_to_pay = 0.0
        this.quote_sequence = quoteSequence

        const account = Account.fromCookieAndLocalStorage()

        if (this.asante_contact_info === null) {
            if (account) {
                this.asante_contact_info =
                    ContactInformationModel.fromAsante(
                        account.settings.asante_contact_info)
            } else {
                this.asante_contact_info =
                    new ContactInformationModel()
            }
        }

        if (this.invoicing_contact_info === null) {
            if (account && account.isCustomer()) {
                this.invoicing_contact_info =
                    ContactInformationModel.from(
                        account.settings.asante_contact_info)
            } else {
                this.invoicing_contact_info =
                    new ContactInformationModel()
            }
        }

        if (this.customer_project_manager === null) {
            this.customer_project_manager =
                new ContactInformationModel()
        }

        if (this.contact_info === null) {
            if (account && !account.hasRole(Roles.Asante)) {
                this.contact_info =
                    ContactInformationModel.from(
                        account.settings.contact_info)
            } else {
                this.contact_info =
                    new ContactInformationModel()
            }
        }

        if (this.shipping_info === null) {
            if (account && !account.hasRole(Roles.Asante)) {
                this.shipping_info =
                    AddressModel.from(
                        account.settings.shipping_info)
            } else {
                this.shipping_info = new AddressModel()
            }
        }

        if (this.given_id === null) {
            if (account) {
                this.given_id = account.settings.quote_number_prefix +
                    dateFormat(new Date(), 'mmddyyyy')
            } else {
                this.given_id = dateFormat(new Date(), 'mmddyyyy')
            }
        }
    }

    /**
     * Create a new Quote from json
     * @param {json} json
     * @return {Quote}
     */
    static from(json) {
        const quote = Object.assign(new Quote(), json)

        for (let i = 0; i < quote.signs.length; i++) {
            quote.signs[i] = Sign.from(quote.signs[i])
        }

        quote.asante_contact_info =
            ContactInformationModel.fromAsante(quote.asante_contact_info)
        quote.invoicing_contact_info =
            ContactInformationModel.from(quote.invoicing_contact_info)
        quote.contact_info = ContactInformationModel.from(quote.contact_info)
        quote.shipping_info = AddressModel.from(quote.shipping_info)
        quote.customer_project_manager = ContactInformationModel.from(
            quote.customer_project_manager,
        )
        // if (!(quote.quote_date instanceof Date)) {
        //     if (quote.quote_date) {
        //         quote.quote_date = new JustDate(quote.quote_date)
        //     } else {
        //         quote.quote_date = new JustDate()
        //     }
        // }
        quote.quote_date = new JustDate(quote.quote_date)
        //          new Date(quote.quote_date.getTime() +
        //              60 * 1000 * (new Date()).getTimezoneOffset())

        quote.shipped_date = new JustDate(quote.shipped_date)
        //          addUserTimeZone(quote.shipped_date)

        if (quote.last_date_paid) {
            quote.last_date_paid = new JustDate(quote.last_date_paid)
        }

        const newHistory = []
        for (let i = 0; i < quote.payment_history.length; i++) {
            newHistory.push(
                PaymentHistory.from(
                    quote.payment_history[i],
                ),
            )
        }
        quote.payment_history = newHistory

        return quote
    }

    /**
     * Copy contact info to shipping info
     */
    copyContactInfoToShippingInfo() {
        this.shipping_info =
            Object.assign(this.shipping_info, this.contact_info)
    }

    /**
     * Auto generates a quote number
     */
    autogenQuoteNumber() {
        const account = Account.fromCookieAndLocalStorage()
        if (!account) {
            this.given_id = dateFormat(new Date(), 'mmddyyyy')
            return
        }

        this.given_id = account.settings.quote_number_prefix +
            (account.isCustomer() ? '-' : '') +
            dateFormat(this.quote_date.toDateTime(), 'mmddyyyy') +
            this.customer_name.substr(0, 3).toUpperCase()
    }

    /**
     * This will fill in inforamtion needed from another quote
     * @param {Quote} quote
     * @param {boolean} overrideFill
     */
    fillInformationFromQuote(quote, overrideFill) {
        if (quote.contact_info) {
            this.contact_info.fillInInformation(
                quote.contact_info, overrideFill)
        }
        if (quote.shipping_info) {
            this.shipping_info.fillInInformation(
                quote.shipping_info, overrideFill)
        }
        if (quote.invoicing_contact_info) {
            this.invoicing_contact_info.fillInInformation(
                quote.invoicing_contact_info, overrideFill)
        }
        if (quote.customerProjectManager) {
            this.customer_project_manager.fillInInformation(
                quote.customer_project_manager, overrideFill)
        }
        if (!this.project_manager || overrideFill) {
            this.project_manager = quote.project_manager
        }
    }

    /**
     * Checks to see if contact_info and shipping_info has information filled in
     * @return {boolean} false iff blank
     */
    hasInformationFilledIn() {
        return !equals(new ContactInformationModel(), this.contact_info) &&
            !equals(new AddressModel(), this.shipping_info)
    }

    /**
     * A quote is "blank" if nothing has been filled in yet - no job_name,
     * and exactly one sign with no given_id/type/addons (a fresh
     * `new Sign()`, per this class's own default). Shared between
     * src/routers/quote.js (server-side gate on the "Suggest from Files"
     * route) and QuoteViewController.js (client-side gate on showing that
     * button) - both need the exact same rule, so it lives here once
     * rather than being hand-duplicated in two runtimes that can drift
     * out of sync with each other.
     * @return {boolean}
     */
    isBlank() {
        if (this.job_name) {
            return false
        }
        if (this.signs.length > 1) {
            return false
        }
        const sign = this.signs[0]
        return !sign ||
            (!sign.given_id && !sign.type?.id && (sign.addons ?? []).length === 0)
    }

    /**
     * @param {json} typeIdToAddon
     * @return {bool} true iff there exist an addon that can
     *      be upgraded
     */
    hasAddonThatCanBeUpgraded(typeIdToAddon) {
        for (let i = 0; i < this.signs.length; i++) {
            if (
                typeIdToAddon[this.signs[i].type.id] &&
                this.signs[i].hasAddonThatCanBeUpgraded(
                    typeIdToAddon[this.signs[i].type.id])
            ) {
                return true
            }
        }

        return false
    }

    /**
     * @param {json} typeIdToAddon
     */
    upgradeAddons(typeIdToAddon) {
        for (let i = 0; i < this.signs.length; i++) {
            this.signs[i].upgradeToNewestAddons(
                typeIdToAddon[this.signs[i].type.id])
        }
    }

    /**
     * This should be made faster by taking advantage of knowing
     * the sign type. Not a big deal unless its slow.
     * @param {AddonWithOptions} addon
     * @return {boolean}
     */
    hasAddonWithOptions(addon) {
        for (let i = 0; i < this.signs.length; i++) {
            if (this.signs[i].hasAddonWithOptions(addon)) {
                return true
            }
        }
        return false
    }

    /**
     * Sorts all addons
     * @param {json} allAddons type_id->[sorted AddonWithOptions]
     */
    sortAddons(allAddons) {
        for (let i = 0; i < this.signs.length; i++) {
            this.signs[i].sortAddons(allAddons)
        }
    }

    /**
     * This will add another adjustment
     */
    addAdjustment() {
        this.adjustments.push(new Adjustment())
    }

    /**
     * @return {string} formatted quote_date
     */
    formatQuoteDate() {
        return dateFormat(this.quote_date.toDateTime(), 'mmmm d, yyyy')
    }

    /**
     * @param {number} payment
     * @param {string} nickname
     * @param {JustDate} date
     */
    addPayment(payment, nickname, date) {
        this.payment_history.push(
            PaymentHistory.from({
                'payment': payment,
                'nick_name': nickname,
                'date': date,
            }),
        )
    }

    /**
     * @return {int} total quantity of signs
     */
    totalSignCount() {
        let count = 0

        for (let i = 0; i < this.signs.length; i++) {
            count += parseInt(this.signs[i].quantity)
        }

        return count
    }

    /**
     * @return {int} total cost of signs
     */
    totalCost() {
        let cost = 0

        for (let i = 0; i < this.signs.length; i++) {
            cost += this.signs[i].totalPriceIncludingSubsigns()
        }

        const totalPercent = this.adjustments.sum((x) => parseFloat(x.percent))
        const totalDollar = this.adjustments.sum((x) => parseFloat(x.dollar))

        cost = cost * (1+totalPercent) + totalDollar
        cost += parseFloat(this.shipping_cost)

        this.total_price = cost

        return cost
    }

    /**
     * @return {number} total payments made
     */
    totalPayments() {
        return this.payment_history.sum((x) => x.payment)
    }

    /**
     * @param {JustDate} dueDate
     * @return {number}
     */
    amountLeftPlusInterest(
        dueDate=new JustDate(),
    ) {
        let daysPassed = (new JustDate()).differanceDays(dueDate)
        if (daysPassed < 0) {
            daysPassed = 0
        }

        return Math.round(
            100 *
            this.left_to_pay * (((1/365) * 0.2) * daysPassed + 1),
        ) / 100
    }

    /**
     * @param {JustDate} dueDate
     * @param {Number} payment
     * @return {number}
     */
    amountLeftPlusInterestThroughPayment(
        dueDate=new JustDate(),
        payment=0,
    ) {
        let paymentLeft = this.total_price
        let interest = null
        for (let i = 0; i <= payment; i++) {
            let daysPassed = this.payment_history[i].date
                .differanceDays(dueDate)
            if (daysPassed < 0) {
                daysPassed = 0
            }

            const newPaymentLeft = Math.round(
                100 *
                paymentLeft * (((1/365) * 0.2) * daysPassed + 1),
            ) / 100

            interest = newPaymentLeft - paymentLeft
            if (daysPassed >= 0) {
                paymentLeft = newPaymentLeft
            }
            paymentLeft -= this.payment_history[i].payment
        }

        return {paymentLeft, interest}
    }
}

module.exports = {
    Quote,
}
